"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTextFieldPhone = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DmsTextFieldMasked = require("./DmsTextFieldMasked");
const _excluded = ["name", "label", "placeholder"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Mask function for Brazilian phone numbers.
 *
 * Formats the input value into the Brazilian phone number format:
 * (XX) XXXXX-XXXX or (XX) XXXX-XXXX.
 *
 * @param {string} value - The raw input value to be masked.
 * @returns {string} The masked value formatted as a Brazilian phone number.
 */
const PhoneMask = value => {
  // Remove all non-numeric characters
  value = value.replace(/\D/g, "");

  // Format based on the length of the input
  if (value.length <= 2) {
    return value;
  } else if (value.length <= 6) {
    return "(".concat(value.slice(0, 2), ") ").concat(value.slice(2));
  } else if (value.length <= 10) {
    return "(".concat(value.slice(0, 2), ") ").concat(value.slice(2, 6), "-").concat(value.slice(6));
  } else {
    return "(".concat(value.slice(0, 2), ") ").concat(value.slice(2, 7), "-").concat(value.slice(7, 11));
  }
};

/**
 * A text field component specifically for entering Brazilian phone numbers.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.name - The name attribute of the input field.
 * @param {string} props.label - The label text displayed for the input field.
 * @param {string} props.placeholder - The placeholder text shown in the input field.
 * @param {string} [props.value] - The current value of the input field.
 * @param {boolean} [props.disabled] - If true, the input field will be disabled.
 * @param {boolean} [props.fullWidth] - If true, the input field will take up the full width of its container.
 * @param {boolean} [props.required] - If true, the input field will be marked as required.
 * @returns {JSX.Element} The rendered TextField component configured for Brazilian phone number input.
 */
const DmsTextFieldPhone = _ref => {
  let {
      name = "phone",
      label = "Phone Number",
      placeholder = "(XX) XXXXX-XXXX"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DmsTextFieldMasked.DmsTextFieldMasked, _extends({
    name: name,
    label: label,
    placeholder: placeholder
  }, props, {
    maskFunction: PhoneMask
  }));
};
exports.DmsTextFieldPhone = DmsTextFieldPhone;
DmsTextFieldPhone.propTypes = {
  name: _propTypes.default.string,
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  value: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  fullWidth: _propTypes.default.bool,
  required: _propTypes.default.bool,
  onChange: _propTypes.default.func
};